import React, { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock, faCheckCircle } from "@fortawesome/free-solid-svg-icons";

import "swiper/css";
import "./VipCard.css";
import { useDispatch, useSelector } from "react-redux";
import { GETAllVipLevel } from "../../../features/auth/Slice";
import { IDS } from "../../../utils/IDS";

const VIP_DATA = {
  "1": {
    bg:
      "url('/assets/images/vip/vip_card/bg_golden.webp') no-repeat center, linear-gradient(117.29deg, #f8bd83 21.85%, #e2984e 67.02%)",
    badge: "/assets/images/vip/vip_badge/vip_golden.webp",
    progressBg: "#a6b7d0",
    expBadge: "#889ebe",
  },
  "2": {
    bg:
      "url('/assets/images/vip/vip_card/bg_blue.webp') no-repeat center, linear-gradient(117.29deg, #54baf1 21.85%, #3d77e8 67.02%)",
    badge: "/assets/images/vip/vip_badge/vip_blue.webp",
    progressBg: "#f8bd83",
    expBadge: "#e2984e",
  },
  "3": {
    bg:
      "url('/assets/images/vip/vip_card/bg_fentGreen.webp') no-repeat center, linear-gradient(117.29deg, #61dca6 21.85%, #229b5f 67.02%)",
    badge: "/assets/images/vip/vip_badge/vip_fentGreen.webp",
    progressBg: "#ffa493",
    expBadge: "#ff7878",
  },
  "4": {
    bg:
      "url('/assets/images/vip/vip_card/bg_green.webp') no-repeat center, linear-gradient(117.29deg, #57b733 21.85%, #229b5f 67.02%)",
    badge: "/assets/images/vip/vip_badge/vip_green.webp",
    progressBg: "#78dbeb",
    expBadge: "#48c7f0",
  },
  "5": {
    bg:
      "url('/assets/images/vip/vip_card/bg_pink.webp') no-repeat center, linear-gradient(117.29deg, #df91fb 21.85%, #ef82d5 67.02%)",
    badge: "/assets/images/vip/vip_badge/vip_pink.webp",
    progressBg: "#df91fb",
    expBadge: "#ef82d5",
  },
  "6": {
    bg:
      "url('/assets/images/vip/vip_card/bg_skyBlue.webp') no-repeat center, linear-gradient(117.29deg, #78dbeb 21.85%, #48c7f0 67.02%)",
    badge: "/assets/images/vip/vip_badge/vip_skyBlue.webp",
    progressBg: "#61dca6",
    expBadge: "#229b5f",
  },
  "7": {
    bg:
      "url('/assets/images/vip/vip_card/bg_red.webp') no-repeat center, linear-gradient(117.29deg, #ffa493 21.85%, #ff7878 67.02%)",
    badge: "/assets/images/vip/vip_badge/vip_red.webp",
    progressBg: "#57b733",
    expBadge: "#229b5f",
  },
  "8": {
    bg:
      "url('/assets/images/vip/vip_card/bg_silver.webp') no-repeat center, linear-gradient(117.29deg, #a6b7d0 21.85%, #889ebe 67.02%)",
    badge: "/assets/images/vip/vip_badge/vip_silver.webp",
    progressBg: "#54baf1",
    expBadge: "#3d77e8",
  },
  "9": {
    bg:
      "url('/assets/images/vip/vip_card/bg_silver.webp') no-repeat center, linear-gradient(117.29deg, #a6b7d0 21.85%, #889ebe 67.02%)",
    badge: "/assets/images/vip/vip_badge/vip_silver.webp",
    progressBg: "#d084e2",
    expBadge: "#8d49ff",
  },
  "10": {
    bg:
      "url('/assets/images/vip/vip_card/bg_silver.webp') no-repeat center, linear-gradient(117.29deg, #a6b7d0 21.85%, #889ebe 67.02%)",
    badge: "/assets/images/vip/vip_badge/vip_silver.webp",
    progressBg: "#fff6bc",
    expBadge: "#f98b3b",
  },
};

function VipCard({
  userVipLevel = 1,
  currentExp = 45000,
  requiredExp = 200000,
  onLevelChange,
}) {
  const levels = Object.keys(VIP_DATA);

  const dispatch = useDispatch();
  const VipLevels = useSelector((state) => state.auth.VipLevels);

  useEffect(() => {
    dispatch(GETAllVipLevel());
  }, [dispatch]);

  return (
    <div className="vip_card_section">
      <div className="vip_note">
        VIP level rewards are settled at 2:00 am on the 1st of every month
      </div>

      <Swiper
        spaceBetween={5}
        slidesPerView={1.1}
        centeredSlides={true}
        initialSlide={userVipLevel - 1}
        grabCursor={true}
        loop={false}
        onSlideChange={(swiper) => {
          if (onLevelChange) onLevelChange(swiper.activeIndex + 1);
        }}
      >
        {VipLevels?.map((levelStr) => {
          const level = levelStr;
          const config = VIP_DATA[`${level?.Vip_Level?.id - 1}`];

          const isLocked = !level?.achieve_status && !level?.active_status;
          const isCurrent =
            Number(level?.Vip_Level?.id) === Number(userVipLevel);

          const isCompleted = level?.achieve_status;
          const progressWidth = Math.min(
            (level?.level_exp / level?.req_total_exp) * 100,
            100,
          );

          return (
            <SwiperSlide key={levelStr?.id}>
              <div
                className={`vip_card ${isLocked ? "card_locked" : ""}`}
                style={{
                  backgroundImage: `url(${IDS.IMG_URL +
                    level?.Vip_Level?.bg_image})`,
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                }}
              >
                <div className="vip_card_top">
                  <div className="vip_left">
                    <div className="vip_title_row">
                      <div className="vip_tick_holder">
                        <img
                          src="/assets/images/vip/vip_icons/golden_crown.webp"
                          className="vip_tick"
                          alt="crown"
                        />
                      </div>

                      <h2>{level?.Vip_Level?.name}</h2>

                      {isLocked && (
                        <span className="vip_lock">
                          <FontAwesomeIcon icon={faLock} /> Not open yet
                        </span>
                      )}
                      {isCompleted && (
                        <span className="vip_unlocked">
                          <FontAwesomeIcon icon={faCheckCircle} /> Acheived
                        </span>
                      )}
                    </div>

                    <p className="vip_desc">
                      {isCompleted
                        ? "Level requirement met"
                        : `Upgrading ${
                            level?.Vip_Level?.name
                          } requires ${level?.Vip_Level?.required_exp?.toLocaleString()} EXP`}
                    </p>

                    <div className="vip_tag">
                      Bet ₹1 = {level?.Vip_Level?.per_bet_exp || 1} EXP
                    </div>
                  </div>

                  <div className="vip_right">
                    <div className="vip_badge_holder">
                      <img
                        src={IDS.IMG_URL + level?.Vip_Level?.crown_image}
                        className="vip_badge"
                        alt={`${level?.Vip_Level?.name}`}
                      />
                    </div>
                  </div>
                </div>

                <div className="vip_progress_wrap">
                  {isCompleted && !isCurrent ? (
                    <span>Received VIP level up bonus</span>
                  ) : isCurrent ? (
                    <>
                      <span className="vip3_text">
                        {level?.Vip_Level?.name}
                      </span>

                      <div
                        className="vip_progress"
                        style={{ background: config?.progressBg }}
                      >
                        <div
                          className="progress_bar"
                          style={{
                            width: `${Math.min(
                              (level?.level_exp / level?.req_total_exp) * 100,
                              100,
                            )}%`,
                            backgroundColor: config?.expBadge,
                          }}
                        ></div>
                      </div>

                      <div className="vip_progress_text">
                        <span>
                          {level?.level_exp?.toLocaleString()}/
                          {level?.req_total_exp?.toLocaleString()}
                        </span>

                        <span>
                          Incomplete will be deducted by the system <br />[
                          {level?.Vip_Level?.maintenance_penalty_exp} EXP]
                        </span>
                      </div>
                    </>
                  ) : (
                    // 🔵 LOCKED / NEXT LEVEL (VIP4)
                    <>
                      <span className="vip3_text">
                        {level?.Vip_Level?.name}
                      </span>

                      <div
                        className="vip_progress"
                        style={{ background: config?.progressBg }}
                      >
                        <div
                          className="progress_bar"
                          style={{
                            width: `${Math.min(
                              (level?.level_exp / level?.req_total_exp) * 100,
                              100,
                            )}%`,
                            backgroundColor: config?.expBadge,
                          }}
                        ></div>
                      </div>

                      <div className="vip_progress_text">
                        <span
                          className="left"
                          style={{ background: config?.expBadge }}
                        >
                          {level?.level_exp?.toLocaleString()}/
                          {level?.req_total_exp?.toLocaleString()}
                        </span>

                        <span className="right">
                          {level?.req_total_exp?.toLocaleString()} EXP can be
                          leveled up
                        </span>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
}

export default VipCard;
